import React, { useState } from "react";
import { Fab, Zoom } from "@mui/material";
import { styled } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles.module.css";

const StyledFab = styled(Fab)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(2),
  background: "#1c3988",
  right: theme.spacing(2),
  "&:hover": {
    backgroundColor: "#253969",
    color: "#fff",
  },
}));

const Actions = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  bottom: theme.spacing(9),
  right: theme.spacing(2),
}));

const ActionFab = styled(Fab)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  "&:hover": {
    backgroundColor: "#1c3988",
    color: "#fff",
  },
}));

const SpeedDial = ({ actions }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <div onMouseLeave={handleClose}>
        <Zoom in={open} unmountOnExit>
          <Actions>
            {actions.map((action, index) => (
              <div
                className={styles.container_buttons}
                onClick={action.onClick}
              >
                <span className={styles.title}>{action.name}</span>
                <ActionFab key={index} size="small">
                  {action.icon}
                </ActionFab>
              </div>
            ))}
          </Actions>
        </Zoom>
        <StyledFab
          color="primary"
          onMouseEnter={handleOpen}
          onClick={open ? handleClose : handleOpen}
        >
          {open ? <CloseIcon /> : <AddIcon />}
        </StyledFab>
      </div>
    </>
  );
};

export default SpeedDial;
